import { render } from "./AcceptTAndC.vue?vue&type=template&id=66b98def&scoped=true"
import script from "./AcceptTAndC.vue?vue&type=script&lang=js"
export * from "./AcceptTAndC.vue?vue&type=script&lang=js"

import "./AcceptTAndC.vue?vue&type=style&index=0&id=66b98def&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b98def"]])

export default __exports__